/* eslint-disable indent */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-unused-vars */
import moment from "moment";
import React, { useState, useEffect } from "react";
import "./style.scss";
import { useNavigate, useLocation } from "react-router-dom";

import API from "../../api";
import urls from "../../api/urls";

import EnrichedBagDetailsUI from "../../components/EnrichedBagDetailsUI";

// DATE FORMATTER
const convertDate = (isoDate) => moment.utc(isoDate).format("DD-MM-YYYY HH:mm");

function ShipmentTracker() {
  const history = useLocation();
  const navigate = useNavigate();
  const { GET_SHIPMENT_TRACKING, GET_SHIPMENT_TRACKING_V2 } = urls;

  const [loading, setLoading] = useState(false);
  const [isShipmentMcn, setIsShipmentMcn] = useState(false);
  const [tableData, setTableData] = useState({});
  const [noDataFound, setNoDataFound] = useState(false);
  const [v2Status, setV2Status] = useState("");

  // unified AWB / Bag number
  const [currentAwb, setCurrentAwb] = useState("");
  const [bagorShipmentId, setBagorShipmentId] = useState("");
  const [isParentShipment, setIsParentShipment] = useState("");

  const [navStack, setNavStack] = useState([]);
  const activeRequestRef = React.useRef(null);

  // API CALL
  const getShipOrBagDetails = async (awbNumber) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setLoading(true);
    setNoDataFound(false);
    setV2Status("");

    let response = await API.Api(
      GET_SHIPMENT_TRACKING + "?awbNumber=" + awbNumber
    ).getWithPremiseHeader();

    setLoading(false);

    if (!response?.status) {
      setNoDataFound(true);
      return;
    }

    const res = response?.response?.data;

    if (res?.statusCode === 400) {
      setNoDataFound(true);
      return;
    }

    const isShipment = !!res?.shipmentTracking;
    const isBag = !!res?.baggingTracking;

    let detectedAwb = "";
    if (isShipment) {
      detectedAwb = res?.shipmentTracking?.bookingInfoDto?.awbNumber || awbNumber;
    } else if (isBag) {
      detectedAwb =
        res?.baggingTracking?.baggingInfo?.bag_barcode || awbNumber;
    } else {
      detectedAwb = awbNumber;
    }

    setCurrentAwb(detectedAwb);
    setBagorShipmentId(detectedAwb);

    setTableData(res);
    setIsShipmentMcn(res?.shipmentTracking?.bookingInfoDto?.mcn ?? false);
    setIsParentShipment(
      res?.shipmentTracking?.bookingInfoDto?.parentAwbNumber || ""
    );
  };

  // Detect AWB from URL or state
  useEffect(() => {
    let awb = history?.state?.awb;
    if (!awb) {
      awb = new URLSearchParams(window.location.search).get("awb");
    }

    if (awb) {
      setCurrentAwb(awb);
      setNoDataFound(false);
      // getShipOrBagDetails(awb);
    }
  }, [history?.state?.awb, history?.state?.num]);

  // CLICK HANDLER
  const handleShipOrBagOnClick = (awb) => {
    if (awb) {
      const url = `/shipment-tracker?awb=${awb}`;
      window.open(url, "_blank");
    }
  };

  return (
    <div className="consolidated-tab-cntr shipment-tracker-wrapper">
      <div
        className="tracker-content-container shipment-tracker-content"
        style={{ background: "#fff", padding: "10px" }}
      >
        <EnrichedBagDetailsUI
          endpoint={GET_SHIPMENT_TRACKING}
          awbNumber={currentAwb?.replace(/\+/g, "/")?.replace(/\s/g, "")}
          showBackArrow={false}
        />
      </div>
    </div>
  );
}

export default ShipmentTracker;
